import { render, staticRenderFns } from "./tdt-control.vue?vue&type=template&id=119b39a6&"
import script from "./tdt-control.vue?vue&type=script&lang=js&"
export * from "./tdt-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports